import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NRTTabContainer from "../../../../../../components/_common/TabContainer"
import EadCourseModulesPage from "./_partials/CourseModules"
import EadForumPage from "./_partials/Forum"
import EadRequests from "../../../../../../requests/ead-requests"
import MCEadTitle from "../../../../../../components/_ead/Title"
import MCEadContentCard from "../../../../../../components/_ead/ContentCard"
import EadTalkToInstructorPage from "./_partials/TalkToInstructor"
import { getClassTypeNameByCode } from "../../../../../../helpers/product"
import EadCouseContents from "./_partials/Contents"
import ListOfStudents from "./_partials/ListOfStudents"
import MCLoadingOverlay from "../../../../../../components/_minha-central/LoadingOverlay"
import ReleaseRequests from "../../../../../../requests/release-requests";
import EadTutorPage from "./_partials/Tutoria"



class NRTEadCoursePage extends Component {
    constructor (props) {
        super(props)
        this.state = {
            initialized: false,
            awaiting: true,
            userTracks: null,
            modules: false,
            activeTabId: "principal"
        }
        this.checkContent = this.checkContent.bind(this)
    }

    static getDerivedStateFromProps(nextProps, state) {

        const { params } = nextProps.match

        return {
            activeTabId: params.tab || 'principal'
        }
    }


    componentDidMount() {

        const { params } = this.props.match
        const { isTeacher } = this.props.context

        const req = isTeacher ?
            ReleaseRequests.getOld(params.accountCode) :
            EadRequests.getAccount(params.accountCode)

        //limpa as respostas do simulado do local storage 
        localStorage.removeItem('questionaryState')

        req
            .then((account) => {
                if (!account)
                    this.onError({ error: 'Curso nao encontrado' }, "Curso não encontrado ou inexistente. Verifique se sua compra está ativa.")
                else {

                    if (isTeacher) {
                        account = {
                            code: account.code,
                            productReleaseDTO: account
                        }
                    }
                    this.afterFoundAccount(account)
                }


            })
            .catch(error => {
                this.onError(error, 'Ocorreu um erro na comunicação com o servidor.')
            })



    }


    afterFoundAccount(account) {

        const { productReleaseDTO } = account
        const { isTeacher, eadRelease: release } = this.props.context
        const { params } = this.props.match



        if (!account.hasEadModule || isTeacher) {


            this.props.context.set({
                eadRelease: account.productReleaseDTO,
                eadAccount: account,
            })

            this.setState({
                awaiting: false,
                initialized: true,
                activeTabId: params.tab || "conteudo"
            })

            return
        }

        //Busca o usuario EAD referente a compra

        EadRequests.searchEadUser({
            prsCode: this.props.context.person.code,
            accCode: account.code,
            active: true
        })
            .then(eadUser => {

                // console.debug(eadUser, 'ead userrrrrrr')

                if (!eadUser) {
                    this.props.context.set({
                        toastMessage: {
                            type: 'warning',
                            content: "Seu usuário do EAD ainda não foi liberado. Entre em contato conosco para verificar o motivo."
                        }
                    })
                }



                this.props.context.set({
                    eadRelease: account.productReleaseDTO,
                    eadAccount: account,
                    eadUser
                })

                this.setState({
                    awaiting: false,
                    initialized: true,
                })
            })
            .catch(error => {
                this.setState({
                    awaiting: false
                })
                this.onError(error, 'Ocorreu um erro inesperado.')
            })
    }


    onError(error, errorMsg) {

        this.setState({
            awaiting: false
        })

        this.props.context.logError(error)

        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: errorMsg
            }
        })
    }

    checkContent(modules) {
        const { params } = this.props.match

        if (modules.length === 0) {
            this.setState({
                activeTabId: params.tab || "principal",
                modules: true
            })
        }
    }

    goToTab = (tab) => {

        const { params } = this.props.match

        if (tab && tab !== this.state.activeTabId)
            this.props.history.replace(`/conta/curso/${params.accountCode}/${tab}`)
    }


    // VALOR DA CONTANTE RELEASE
    render() {

        const {
            activeTabId,
            awaiting,
            initialized,
            modules
        } = this.state

        if (awaiting || !initialized)
            return <MCLoadingOverlay show={awaiting} />


        const {
            eadAccount: account,
            eadRelease: release,
            eadUser: user,
            isTeacher,
            schemaInfo
        } = this.props.context


        const accountCode = account.code

        return (

            <div className={'nrt-ead-course-page'}>
                <MCEadTitle title={release.name} />


                <div className="tabs-wrapper">

                    <NRTTabContainer activeTabId={activeTabId}
                        onTabClick={this.goToTab}
                        handleTabChange={false}
                        tabs={(() => {
                            const tabs = [
                                {
                                    id: 'principal',
                                    label: 'Apresentação',
                                    content: <MCEadContentCard>
                                        <div dangerouslySetInnerHTML={{ __html: release.welcomepage }} />
                                    </MCEadContentCard>
                                },
                                {
                                    id: 'materiais',
                                    label: 'Materiais de aula',
                                    content: <MCEadContentCard>
                                        <EadCouseContents release={release}
                                            context={this.props.context}
                                        />
                                    </MCEadContentCard>
                                },
                                {
                                    id: 'conteudo',
                                    label: (!!schemaInfo.hasEad ? 'Conteúdo' : 'Simulados'),
                                    disabled: !user || modules,
                                    content: <MCEadContentCard>
                                        {
                                            release && !!user &&
                                            <EadCourseModulesPage release={release}
                                                account={account}
                                                user={user}
                                                history={this.props.history}
                                                context={this.props.context}
                                                checkContent={this.checkContent}
                                            />
                                        }

                                    </MCEadContentCard>
                                },
                                {
                                    id: 'forum',
                                    label: 'Fórum',
                                    content: <MCEadContentCard>
                                        <EadForumPage match={this.props.match}
                                            history={this.props.history}
                                            context={this.props.context}
                                            release={release}
                                            accountId={accountCode}
                                        />
                                    </MCEadContentCard>

                                },
                                {
                                    id: 'fale',
                                    label: 'Fale com o professor',
                                    content: (
                                        <EadTalkToInstructorPage release={release}
                                            context={this.props.context}
                                            person={this.props.person}
                                        />
                                    )
                                },
                                {
                                    id: 'alunos',
                                    label: 'Lista de alunos',
                                    content: <MCEadContentCard>
                                        <ListOfStudents release={release}
                                            context={this.props.context}
                                        />
                                    </MCEadContentCard>
                                },
                                {
                                    id: 'tutoria',
                                    label: 'Tutoria',
                                    content: <MCEadContentCard>
                                        <EadTutorPage match={this.props.match}
                                            history={this.props.history}
                                            context={this.props.context}
                                            release={release}
                                            accountId={accountCode}
                                        />
                                    </MCEadContentCard>

                                },
                            ]

                            /*if (getClassTypeNameByCode(release.productDTO.classType) !== 'Online'){                                                
                                   delete tabs[0]
                            }   */

                            if (isTeacher)
                                delete tabs[4]
                            else
                                delete tabs[5]

                            if (!schemaInfo.hasEad)
                                delete tabs[6]

                            return tabs
                        })()}
                    />
                </div>


            </div>
        )
    }
}


NRTEadCoursePage.propTypes = {
    context: PropTypes.object.isRequired,

}
NRTEadCoursePage.defaultProps = {}

export default NRTEadCoursePage



// WEBPACK FOOTER //
// ./src/_pages/Account/_pages/CourseList/_pages/Course/index.js